import React, { useEffect } from 'react'
import { useGeoState } from '../components/GeoProvider'
import { toast } from 'react-toastify'
const ExportExcelApi = ({ disease }) => { 
   
  const { setExportButtonState } =useGeoState()

  
    useEffect(() => {
     fetch(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/exportexcel?disease=${disease}`,
      {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          requester: JSON.stringify(window.localStorage.getItem('requester')),
        },
        withCredentials: true,
        credentials: 'include',
      }
    )
      .then((response) => response.json())
      .then((excelData)=>{
        if (excelData !== null && excelData !== undefined) {
          if (excelData.response_code === 200) {
            const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${excelData.response_data.Base64string}`;
            const downloadLink = document.createElement("a");
            downloadLink.href = linkSource;
            downloadLink.target = "_blank";
            downloadLink.setAttribute(
              'download',
              excelData.response_data.Filename,
            );
            downloadLink.click();
             toast.dismiss()
             toast.success(excelData.response_message, {
                 position: "top-right",  
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: false,
                 progress: 0,  
                 autoClose: 2000
                 
                 });
            setExportButtonState(false)
          } else {
             toast.error(excelData.response_message, {toastId: 'failure',})
            setExportButtonState(false)
          }
         
        }
      })
    })
  return (
    <>
  
    </>
  )
}

export default ExportExcelApi